import { t } from "@lingui/macro";
import { ArrowRight, Check } from "@phosphor-icons/react";
import { Button } from "@stylingcv/ui";
import { cn } from "@stylingcv/utils";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export const FinalCTASection = () => {
  return (
    <section id="final-cta" className="relative overflow-hidden bg-[#FDFBF7] py-24 sm:py-32">
      <div className="container relative z-10 px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-4xl text-center">
          {/* Main Heading */}
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="mb-6 font-serif text-4xl lg:text-6xl font-extrabold tracking-tight text-[#3e3431]"
          >
            {t`Ready to Land Your Dream Job?`}
          </motion.h2>

          {/* Description */}
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="mb-10 text-center text-lg font-medium text-[#475569] max-w-2xl mx-auto"
          >
            {t`Stop being rejected by robots. Start getting interviews.`}
          </motion.p>

          {/* Action Button */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="flex flex-col items-center justify-center text-center"
          >
            <Button
              asChild
              size="lg"
              className="group relative flex items-center gap-3 overflow-hidden rounded-full bg-[#14b88a] pl-8 pr-3 py-8 text-lg font-bold text-white transition-all hover:scale-[1.02] active:scale-[0.98] shadow-[0_10px_30px_-10px_rgba(20,184,138,0.5)] hover:bg-[#119e76]"
            >
              <Link to="/ai-generator">
                {t`Create Your Winning Resume`} 
                <span className="flex size-10 items-center justify-center rounded-full bg-white/20 transition-transform group-hover:translate-x-1 group-hover:-translate-y-[1px]">
                  <ArrowRight weight="bold" className="size-5" />
                </span>
              </Link>
            </Button>
          </motion.div>

          {/* Trust Indicators */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.6 }}
            className="mt-12 flex flex-wrap items-center justify-center gap-x-8 gap-y-4 text-[13px] font-bold text-[#3e3431]/60 uppercase tracking-[0.1em]"
          >
            <div className="flex items-center gap-2">
              <Check weight="bold" className="size-4 text-[#14b88a]" />
              <span>{t`Free to try`}</span>
            </div>
            <div className="flex items-center gap-2">
              <Check weight="bold" className="size-4 text-[#14b88a]" />
              <span>{t`No credit card`}</span>
            </div>
            <div className="flex items-center gap-2">
              <Check weight="bold" className="size-4 text-[#14b88a]" />
              <span>{t`Ready in 5 minutes`}</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
